export default theme => ({
  placeholder: {
    [theme.breakpoints.up('md')]: {
      height: theme.spacing.unit * 10
    },
    [theme.breakpoints.down('md')]: {
      height: theme.spacing.unit * 6
    }
  },
  root: {
    position: 'fixed',
    top: 0,
    right: 0,
    left: 0,
    zIndex: 100,
    backgroundColor: '#fff',
    boxShadow: theme.shadows[0],
    transition: {
      property: 'box-shadow',
      duration: theme.transitions.duration.shortest,
      timingFunction: theme.transitions.easing.easeIn
    }
  },
  rootWithShadow: {
    boxShadow: theme.shadows[4]
  },
  rootInner: {
    extend: 'placeholder',
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
  },
  logoContainer: {
    flex: 1
  },
  logo: {
    height: theme.spacing.unit * 3,
    width: 'auto',
    fill: theme.palette.secondary.A400
  },
  desktopMenu: {
    marginRight: -theme.spacing.unit * 2,
    marginLeft: -theme.spacing.unit * 2,
    '& > a': {
      margin: `0 ${theme.spacing.unit * 2}px`,
      fontWeight: 300,
      transition: {
        property: 'color',
        duration: theme.transitions.duration.short,
        timingFunction: theme.transitions.easing.easeIn
      },
      '&:hover': {
        color: theme.palette.primary['500']
      }
    }
  },
  activeDesktopMenuLink: {
    color: theme.palette.primary['500']
  },
  mobileMenuButton: {
    transform: 'translateX(22px)'
  }
});



// WEBPACK FOOTER //
// ./src/components/Header/styles.js